import React, {FC} from 'react';

interface LaserGunCardProps {
    background: string,
    description?: string,
    selected: boolean,
    onClick: () => void
}

const LaserGunCard: FC<LaserGunCardProps> = ({background, description, onClick, selected}) => {
    return (
        <div className="">
            <div className={"rounded-lg shadow-lg bg-white item-card " + (selected ? ' shadow-amber-600 selected-card' : '')}
                 onClick={onClick}>
                <button style={{padding: 0}}></button>
                <div className={"item-card-image-div"}>
                    <img src={background} alt={description} />
                </div>
                <div className="p-2">
                    <p className="text-gray-700 text-base mb-4">
                        {description}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default LaserGunCard;
